module.exports = __webpack_public_path__ + "media/app/assets/imgs/exchange/follow-6c279f5015df086f459238e57dae5d6c.png";